import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Effects from "./Effects";
import StudioAdvancedEditor from "../editorToolbar/commonEditorToolbar/StudioAdvancedEditor";
import { openAdvancedSettings } from "../../../_actions/sidebarSliderActions";
import {
  ADVANCED_EDITOR_LAYERS,
  ADVANCED_EDITOR_EFFECTS,
  ADVANCED_EDITOR_EDIT,
  ADVANCED_EDITOR_PANEL,
  ADVANCED_EDITOR_RESIZE,
  ADVANCED_EDITOR_CLIP,
  MIME_TYPE_GIPHY,
  MIME_TYPE_SHAPE,
  MIME_TYPE_TEXT,
  MIME_TYPE_VIDEO,
} from "../constants";
import SlideLayers from "./slideLayers/SlideLayers";
import SlidePresets from "./SlidePresets";
import AdvancedCropAndClipPanel from "./croppingAndClipping/AdvancedCropAndClipPanel";
import { FaCog, FaCropAlt, FaLayerGroup, FaMagic } from "react-icons/fa";
import {
  TabList,
  Tabs,
  Tab,
  HStack,
  Text,
  TabPanel,
  TabPanels,
  Flex,
  Icon,
} from "@chakra-ui/react";
import { ReactComponent as ResizeMotion } from "../../../assets/icons/resize.svg";
import { white } from "../../styled/variable";

export class StudioAdvancedSidebar extends Component {
  onTabSelected = (selectedTabIndex) => {
    switch (selectedTabIndex) {
      case 0:
        this.props.openAdvancedSettings(
          ADVANCED_EDITOR_PANEL,
          ADVANCED_EDITOR_EDIT
        );
        break;
      case 1:
        if (!this.props?.editor?.activeElement?.mime) {
          this.props.openAdvancedSettings(
            ADVANCED_EDITOR_PANEL,
            ADVANCED_EDITOR_RESIZE
          );
        } else if (
          this.props?.editor?.activeElement?.mime === MIME_TYPE_GIPHY ||
          this.props?.editor?.activeElement?.mime === MIME_TYPE_SHAPE
        ) {
          this.props.openAdvancedSettings(
            ADVANCED_EDITOR_PANEL,
            ADVANCED_EDITOR_LAYERS
          );
        } else {
          this.props.openAdvancedSettings(
            ADVANCED_EDITOR_PANEL,
            ADVANCED_EDITOR_EFFECTS
          );
        }
        break;
      case 2:
        if (!this.props?.editor?.activeElement?.mime) {
          this.props.openAdvancedSettings(
            ADVANCED_EDITOR_PANEL,
            ADVANCED_EDITOR_LAYERS
          );
        } else if (
          this.props?.editor?.activeElement?.mime === MIME_TYPE_TEXT ||
          this.props?.editor?.activeElement?.mime === MIME_TYPE_VIDEO
        ) {
          this.props.openAdvancedSettings(
            ADVANCED_EDITOR_PANEL,
            ADVANCED_EDITOR_LAYERS
          );
        } else {
          this.props.openAdvancedSettings(
            ADVANCED_EDITOR_PANEL,
            ADVANCED_EDITOR_CLIP
          );
        }
        break;
      default:
        this.props.openAdvancedSettings(
          ADVANCED_EDITOR_PANEL,
          ADVANCED_EDITOR_LAYERS
        );
        break;
    }
  };

  render() {
    const { canvasRef, artBoardHandler, selectedTab, editor } = this.props;
    const mime = editor.activeElement.mime;

    const isShowClipTab = mime === "image";
    const isShowEffectsTab = ["image", "text", "video"].includes(mime);

    const tabs = [
      ADVANCED_EDITOR_EDIT,
      ...(!mime ? [ADVANCED_EDITOR_RESIZE] : []),
      ...(isShowEffectsTab ? [ADVANCED_EDITOR_EFFECTS] : []),
      ...(isShowClipTab ? [ADVANCED_EDITOR_CLIP] : []),
      ADVANCED_EDITOR_LAYERS,
    ];

    const activeTabIndex = tabs.findIndex((item) => item === selectedTab);

    return (
      <>
        <Flex direction="column" grow={1}>
          <Tabs
            defaultIndex={activeTabIndex}
            id="advanced-sidebar-tab"
            variant={"panel"}
            index={activeTabIndex}
            onChange={this.onTabSelected}
            h={"100%"}
            isFitted
            isLazy
          >
            <TabList>
              <Tab>
                <HStack>
                  <Icon as={FaCog} fontSize="sm" />
                  <Text textTransform={"capitalize"} fontSize={"xs"}>
                    {ADVANCED_EDITOR_EDIT}
                  </Text>
                </HStack>
              </Tab>

              {/* Show 'Resize' for 'Artboard' only */}
              {!mime && (
                <Tab>
                  <HStack>
                    <ResizeMotion fill={white}/>
                    <Text textTransform={"capitalize"} fontSize={"xs"}>
                      {ADVANCED_EDITOR_RESIZE}
                    </Text>
                  </HStack>
                </Tab>
              )}

              {/* Show 'Filters' for images only */}
              {isShowEffectsTab && (
                <Tab>
                  <HStack>
                    <Icon as={FaMagic} fontSize="sm" />
                    <Text textTransform={"capitalize"} fontSize={"xs"}>
                      {ADVANCED_EDITOR_EFFECTS}
                    </Text>
                  </HStack>
                </Tab>
              )}

              {/* Show 'Crop & Clip' for images only */}
              {isShowClipTab && (
                <Tab>
                  <HStack>
                    <Icon as={FaCropAlt} fontSize="sm" />
                    <Text textTransform={"capitalize"} fontSize={"xs"}>
                      {ADVANCED_EDITOR_CLIP}
                    </Text>
                  </HStack>
                </Tab>
              )}
              {/* Show 'Layers' for all layers */}
              <Tab>
                <HStack>
                  <Icon as={FaLayerGroup} fontSize="sm" />
                  <Text textTransform={"capitalize"} fontSize={"xs"}>
                    {ADVANCED_EDITOR_LAYERS}
                  </Text>
                </HStack>
              </Tab>
            </TabList>
            <TabPanels>
              <TabPanel
                flex={1}
                flexBasis={0}
                overflow={"hidden auto"}
                height={"100%"}
                pr={3}>
                <StudioAdvancedEditor
                  canvasRef={canvasRef}
                  artBoardHandler={artBoardHandler}
                />
              </TabPanel>

              {!mime && (
                <TabPanel>
                  <SlidePresets
                    selectedTab={selectedTab}
                    canvasRef={canvasRef}
                  />
                </TabPanel>
              )}

              {isShowEffectsTab && (
                <TabPanel 
                  flex={"1 1 0"} 
                  overflow={"hidden auto"}>
                  <Effects canvasRef={canvasRef} />
                </TabPanel>
              )}

              {isShowClipTab && (
                <TabPanel 
                  flex={"1 1 0"} 
                  overflow={"hidden auto"}>
                  <AdvancedCropAndClipPanel canvasRef={canvasRef} />
                </TabPanel>
              )}

              <TabPanel>
                <SlideLayers canvasRef={canvasRef} />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Flex>
      </>
    );
  }
}

StudioAdvancedSidebar.propTypes = {
  selectedTab: PropTypes.string.isRequired,
  editor: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  selectedTab: state.rightsidebar.selectedTab,
  editor: state.editor,
  isMobileView: state.app.isMobileView,
});

const mapDispatchToProps = (dispatch) => ({
  openAdvancedSettings: (panel, selectedTab) =>
    dispatch(openAdvancedSettings(panel, selectedTab)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudioAdvancedSidebar);
